import { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { useParams } from 'react-router-dom';
import Autocomplete from '@mui/material/Autocomplete';
import InputAdornment from '@mui/material/InputAdornment';
import PropTypes from 'prop-types';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';

import { ASSIGN_MEMBER } from '../../apis/member';
import useLoader from '../../context/LoaderContext';
import useProjectVersionHistory from '../../context/VersionHistoryContext';
import UserDialog from './MultipleAssignDialog';

const propTypes = {
  tableId: PropTypes.string.isRequired,
  skillId: PropTypes.number.isRequired,
  closePopoverHandler: PropTypes.func.isRequired,
  getTeamMembers: PropTypes.func.isRequired,
  userList: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired,
};

const AutoCompleteRenderPropTypes = {
  props: PropTypes.oneOfType([PropTypes.object]),
  option: PropTypes.shape({
    displayName: PropTypes.string,
    id: PropTypes.number,
  }),
};

const AutoCompleteRender = (props, option) => {
  const { displayName, id } = option;
  return (
    <li className="test" {...props} key={displayName + id}>
      {`${displayName}`}
    </li>
  );
};

const AssignMemberSearch = (props) => {
  // init
  const { setIsLoading } = useLoader();
  const { tableId, skillId, userList, closePopoverHandler, getTeamMembers, handleOnChange } = props;
  const { setUndoEdits, setRedoEdits } = useProjectVersionHistory();
  const projectId = useParams();

  // states
  const [memberLoading, setMemberLoading] = useState(false);
  const [open, setOpen] = useState(false);

  // mutations/queries
  const [assignMemberMutation] = useMutation(ASSIGN_MEMBER);

  const handleClose = () => {
    setOpen(false);
    closePopoverHandler();
  };

  const assignMember = async (event, value) => {
    setIsLoading(true);
    try {
      const variables = {
        input: {
          userId: parseInt(value.userId, 10),
          workspaceProfileId: parseInt(value.id, 10),
          projectId: parseInt(projectId.id, 10),
          skillId: parseInt(skillId, 10),
          projectSkillId: parseInt(tableId, 10),
        },
      };
      await assignMemberMutation({ variables });
      setUndoEdits(true);
      setRedoEdits(true);
      handleOnChange();
      getTeamMembers();
    } catch (error) {
      closePopoverHandler();
    }
  };

  useEffect(() => {
    setMemberLoading(true);
  }, []);

  const filterOption = (options, state) => {
    const newOptions = [];
    options.forEach((element) => {
      if (state.inputValue !== '') {
        if (element.displayName.replace(',', '').toLowerCase().includes(state.inputValue.toLowerCase())) {
          newOptions.push(element);
        }
      } else {
        newOptions.push(element);
      }
    });
    return newOptions;
  };

  return (
    <div>
      {memberLoading && (
        <Autocomplete
          className="assign-member-searchbar"
          options={userList}
          renderOption={AutoCompleteRender}
          filterOptions={filterOption}
          autoComplete
          getOptionLabel={(option) => `${option.displayName}`}
          onChange={assignMember}
          renderInput={(params) => (
            <TextField
              className="search-input"
              {...params}
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
              placeholder="Search for team members"
            />
          )}
        />
      )}
      <UserDialog open={open} handleClose={handleClose} />
    </div>
  );
};

AutoCompleteRender.propTypes = AutoCompleteRenderPropTypes;
AssignMemberSearch.propTypes = propTypes;
export default AssignMemberSearch;
